import React from 'react';
import styles from '../styles.module.css';
import { faPlate } from '@/functions/formats';
import MainIcons from '@/icons/main';
import { Plate, SubUser, userInfo } from '@/commonTypes';

export default function SubUserItem({
  onDelete,
  onOpen,
  onSync,
  name,
  plate,
  item,
  syncLoading,
}: {
  item: SubUser;
  plate?: Plate | null;
  name?: string;
  onOpen?: (x: SubUser) => void;
  onDelete?: (x: SubUser) => void;
  onSync?: (x: SubUser) => void;
  syncLoading?: string | number;
}) {
  return (
    <div className={styles.card}>
      <div className={styles.actions}>
        {onDelete && (
          <button className={styles.deleteButton} onClick={() => onDelete(item)}>
            <MainIcons.deleteIcon fill="var(--danger)" width={'19px'} height={'19px'} />
          </button>
        )}

        {onOpen && (
          <button className={styles.openButton} onClick={() => onOpen(item)}>
            <MainIcons.arrowDiagonalIcon fill="var(--brand-dark)" width={'19px'} height={'19px'} />
          </button>
        )}
        {onSync && (
          <button className={styles.openButton} onClick={() => onSync(item)}>
            <MainIcons.RefreshIcon
              fill="var(--brand-dark)"
              width={'19px'}
              height={'19px'}
              className={syncLoading == item?.id ? styles.spin : ''}
            />
          </button>
        )}
      </div>

      <div className={styles.user}>
        <div className={styles.info}>
          <span className={styles.name}>{name}</span>
          <span className={styles.plate} dir="ltr">
            {plate && faPlate(plate)}
          </span>
        </div>

        <div className={styles.avatar}>
          <MainIcons.userIcon fill="var(--brand-dark)" />
        </div>
      </div>
    </div>
  );
}
